import { render, staticRenderFns } from "./cognitoCcList.vue?vue&type=template&id=646585f4&"
import script from "./cognitoCcList.vue?vue&type=script&lang=js&"
export * from "./cognitoCcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports